import './styles/screen';
import './main';
